import { createSelector } from 'reselect';
import {
  zipCodeRegExpressionKey,
  zipCodeMaskKey,
  twoLetterCountryCodeKey,
} from '../../../constants/countryProperties';

export const countrySelector = (state) =>
  state.ascendon?.metadata?.code[59]?.Codes || [];

export const selectedCountryProperties = (state, selectedCountry) =>
  countrySelector(state).find(
    (countryItem) => countryItem.Value === selectedCountry,
  );

const getAdditionalProperty = (properties, key) =>
  properties?.AdditionalProperties?.find(
    (additionalPropertyItem) =>
      additionalPropertyItem.Key === key && additionalPropertyItem.Value,
  );

export const getSelectedCountryPostalCodeRegex = createSelector(
  selectedCountryProperties,
  (countryProperties) =>
    getAdditionalProperty(countryProperties, zipCodeRegExpressionKey),
);

export const getSelectedCountryZipCodeMask = createSelector(
  selectedCountryProperties,
  (countryProperties) =>
    getAdditionalProperty(countryProperties, zipCodeMaskKey),
);

export const getCountryCodeList = createSelector(
  countrySelector,
  (countryList) =>
    countryList.map((country) => {
      const countryProperties = getAdditionalProperty(
        country,
        twoLetterCountryCodeKey,
      );
      return countryProperties.Value;
    }),
);

export const getSelectedCountry = (state, selectedCountry2LetterCode) =>
  countrySelector(state).find((countryItem) => {
    const countryProperties = getAdditionalProperty(
      countryItem,
      twoLetterCountryCodeKey,
    );
    return selectedCountry2LetterCode === countryProperties.Value;
  });

export const getTwoLetterCountryCodeFromThreeLetterCountryCode = (
  state,
  selectedCountry3LetterCode,
) =>
  getAdditionalProperty(
    countrySelector(state).find(
      (countryItem) => selectedCountry3LetterCode === countryItem.Value,
    ),
    twoLetterCountryCodeKey,
  )?.Value;

export const getSelectedTwoLetterCountry = (
  state,
  selectedCountry,
  isSelectedCountry,
) => {
  if (!isSelectedCountry) return selectedCountry;
  const getSelectedCountryItem = countrySelector(state).find(
    (countryItem) => countryItem.Value === selectedCountry,
  );
  const countryProperties = getAdditionalProperty(
    getSelectedCountryItem,
    twoLetterCountryCodeKey,
  );
  return countryProperties?.Value;
};
